// @flow
import React, { Component, Fragment } from 'react'
import { batch } from 'react-redux' // eslint-disable-line no-restricted-imports
import { css } from 'glamor'
import glamorous from 'glamorous'
import content from 'pp-react-l10n'
import { connect } from 'transfer/utils/p2p-connect'
import { isEmpty, get } from 'lodash'
import { smallAndBigger, mobileAndSmaller } from 'lib/styles/media-queries'
import Banner from 'calculator/containers/main/banner'
import RecipientHeader from '../recipient-header'
import XBFeeMismatch from '../xb-fee-mismatch'
import SendSelectedFundingOption from '../send-selected-funding-option'
import * as travelRuleUtils from 'transfer/utils/travelRuleUtils'
import { handleCancelRedirect } from 'transfer/utils/pisp-utils'
import TravelRule from '../travelRule'
import UnilateralFields from '../unilateral'
import PaymentTypeChoiceOverpanel from '../unified/payment-type-choice'
import ThemeSelectionOverpanel from '../theme-selection-overpanel'
import ThreeDSOverpanel from './threeDS-overpanel'
import ThreeDS2OverPanel from '../3DS2/ThreeDS2OverPanel'
import ThreeDS2SpinnerOverpanel from '../3DS2/ThreeDS2SpinnerOverpanel'
import CurrencyConversionSelectionOverpanel from './currency-conversion-selection-overpanel'
import * as SendActions from '../../actions/send'
import * as PayRequestActions from '../../actions/pay-request'
import Disclosure from './disclosure'
import * as ViewActions from 'transfer/actions/Actions'
import { routeTo } from 'transfer/utils/routeHelper'
import { getFlowType, parseSearch } from 'transfer/utils/url-utils'
import NoteWithGift from './note-with-gift'
import GiftOptions from '../gift-options/gift-options'
import DonateAnonymousCheckbox from '../donate/donateAnonymousCheckbox'
import NewThemeSelectionOverpanel from '../gift-options/new-theme-selection-overpanel'
import {
  trackClickUnifiedSend,
  trackAmountPageClick,
  trackAmountPageImpression,
  getAnalytics,
  getPageGroup,
  getPageName,
} from 'transfer/utils/unified-send-analytics'
import PaymentTypeToggle from '../unified/payment-type-choice/payment-type-toggle'
import ConvertibleAmountField from './convertible-amount-field'
import { isPhoneNumberMaybe } from 'transfer/utils/phoneUtils'
import * as OverpanelActions from '../../actions/overpanels'
import {
  getOptionById,
  isFundingOptionAvailable,
  shouldShowSelectorInterstitial,
  justSelectedFundingOption,
  justSetPreferredSource,
  isSendAbroadFlow,
  getRelevantFundingSource,
  getPreferredFundingSource,
  getFundingSourceName,
} from 'transfer/utils/funding-option-utils'
import { trackImpression, trackLink } from 'lib/analytics/fpti'
import { tracking } from 'lib/analytics/mParticle'
import { getFeePayerTracking } from 'lib/analytics/helper'
import Events from 'lib/analytics/eventTags'
import {
  amountIsZero,
  amountAboveMinimumDonation,
  amountBelowMaximumDonation,
} from 'lib/amountUtils'
import { trackPurchaseProtectionSelection } from '../../utils/purchase-protection-analytics'
import DocumentTitle from 'react-document-title'
import { getExternalComponents as getHookComponents } from 'transfer/hooks'
import ShippingAddressDropdown from '../shippingAddressDropdown'
import DonateGiftAid from './donate-gift-aid'
import {
  togglePaymentTypeChoiceOverpanel,
  redirectToDolphin,
  sendMoreInfoToAssessCapabilities,
  trackServiceAndClientDecision,
  updateTxn,
  redirectToHomeinfo,
  initializeMGMAmount,
} from '../../actions/unified-actions'
import CIPOverpanels from '../nobalance/cip-overpanels'
import {
  extract3DS2Contingency,
  collectBrowserContext,
  isBrowserBackPressedFor3DSFlow,
} from '../../utils/3ds-utils'
import PurchaseProtectionCheckbox from '../purchase-protection-checkbox'
import {
  FEE_REQUIRED_VARIANTS,
  PRODUCT_FLOWS,
  SHIPPING_TYPES,
} from '../../../../../lib/constants'
import { showGiftOptions } from '../../../experiments/gift-options'
import {
  GIFT_OPTIONS,
  OPEN_BANKING_FLOWS,
  PROFILE_SOURCE,
  ActionTypes as types,
  DONATION_VALIDATION_TYPES,
  REQUIRED_FLOW_ATTRIBUTES,
  FLOW_TYPES,
} from '../../constants'
import { hasTwentyFourHourHoldsVariant } from 'transfer/utils/risk-hold-utils'
import RiskHoldsOverpanel from 'transfer/components/risk-hold/risk-hold-overpanel'
import ConfirmIdentityOverpanel from '../confirmIdentityOverpanel/confirmIdentityOverpanel'
import { isEmail } from '../../../../../shared/validators'
import enRTRStrings from '../../../../../config/enRTRStrings'
import { handleInterstitialCipFlow } from '../../utils/homeInfoUtils'
import { hasMgmCustomNotesTreatment } from 'experiments/mgm'
import {
  getTrafficSource,
  setMgmTrackingCommonProps,
} from '../../utils/mgmUtils'
import serverProps from '../../utils/serverProps'
import { isHideShippingAddress } from '../../../../../lib/address'

import { getCurrencyCodeMessage } from '../../utils/currencyConversionFeeDisclaimer-utils'
import {
  Button,
  CaptionText,
  Link as PPLink,
  v2grey600,
} from '@paypalcorp/pp-react'
import NoteFieldMandatoryError from './note-field-mandatory-error'
import { mandatoryNoteMissing } from '../../actions/Actions'
import { isDw2Repaint } from 'experiments/dw2Repaint'
import { BOX_BORDER_STYLES } from 'lib/styles/styles'
import ButtonLink from 'react-components/buttonLink'
import { getFundingNameType } from '../../utils/funding-option-utils'
import { hasMultiItemCartShops } from '../../../experiments/shops'
import PurchaseConsentCheckBox from '../purchaseConsentCheckBox'

// colors from http://vxlib.paypalcorp.com/docs/#colors
const vxGray = '#9DA3A6'
const vxDarkGray = '#2c2e2f'

let i18n = content('transfer/page/preview')
const showNewGiftOptions = showGiftOptions()
const { env = '' } = serverProps

/**
 * We use Preview componnet in both amount page and review page. This function decides
 * which page the user is in. User is in reivew page when:
 * 1. user has selected a funding option, OR
 * 2. user has fetched funding option, but does not have any funding option
 */
export function isReviewPage({
  hasFetchedFundingOptions,
  fundingOptions,
  selectedFundingOption,
  flowType,
  isDCSendMoneyRequest,
  isMissingMandatoryNote,
}: {
  hasFetchedFundingOptions: boolean,
  fundingOptions: Array<FundingOption>,
  selectedFundingOption: FundingOption,
  flowType: string,
  isDCSendMoneyRequest: boolean,
  isMissingMandatoryNote: boolean,
}): boolean {
  const hasSelectedFundingOption = !!selectedFundingOption.id
  const hasFundingOptions = !!fundingOptions.length
  // For DC send money request flow review mode should be active if flowType is present
  if (flowType && isDCSendMoneyRequest) {
    return true
  }

  return (
    (hasSelectedFundingOption && !isMissingMandatoryNote) ||
    (hasFetchedFundingOptions && !hasFundingOptions && !isMissingMandatoryNote)
  )
}

export function getSubmitButtonContent({
  amount = '',
  isRecurring,
  isReview,
  shouldShowDonateContent,
  isDCSendMoneyRequest,
  isPSAEnabled,
}: {
  amount: string,
  isRecurring: boolean,
  isReview: boolean,
  shouldShowDonateContent: boolean,
  isDCSendMoneyRequest: boolean,
  isPSAEnabled: boolean,
}) {
  const contentKeyDonate = isRecurring
    ? i18n('input.donateRecurring', { amount })
    : i18n('input.donate')

  const contentKeySend = isPSAEnabled
    ? i18n('input.confirmAndSend')
    : i18n('input.send')

  const contentKey = shouldShowDonateContent ? contentKeyDonate : contentKeySend

  return isReview && !isDCSendMoneyRequest ? contentKey : i18n('input.continue')
}

const Form = glamorous.form({
  position: 'relative',
  padding: 0,
  maxWidth: isDw2Repaint() ? 550 : 500,
  margin: '0 auto',
  // Use padding for when external routes are loaded in iframes
  // this will allow to correctly calculate the height of the iframe
  paddingTop: '15px',
  [smallAndBigger]: {
    paddingTop: '40px',
  },
})

const HeaderBoxWrapper = glamorous.div(
  {
    textAlign: 'center',
    background: 'white',
    marginBottom: isDw2Repaint() ? '1rem' : 15,
    padding: '20px 20px 5px 20px',
    border: '1px solid #f2f2f2',
    [smallAndBigger]: {
      padding: isDw2Repaint()
        ? '2.5rem 3.125rem 0.3125rem 3.125rem'
        : '50px 50px 5px 50px',
    },
    ...(isDw2Repaint() && { ...BOX_BORDER_STYLES }),
  },
  ({ condense }) =>
    condense && {
      border: 'none',
      [smallAndBigger]: {
        padding: 0,
      },
      paddingTop: 0,
      paddingBottom: 0,
    }
)

const CancelLinkWrapper = glamorous.div({
  display: 'block',
  textAlign: 'center',
  margin: '0 auto',
})

const PurchaseProtectionTextDiv = glamorous.p({
  textAlign: 'center',
})

const PurchaseConsentCheckBoxWrapper = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '28px',
  marginTop: '50px',
  fontSize: '16px',
})

const ProtectionENSubTextRTR = glamorous.p({
  display: 'inline',
  color: v2grey600,
})

type NegativeBalanceProps = {
  selectedFundingOption: FundingOption,
}
const NegativeBalance = ({
  selectedFundingOption: { negativeBalance },
}: NegativeBalanceProps) =>
  Boolean(negativeBalance) && (
    <Banner
      error={{
        message: i18n('info.negativeBalance', { negativeBalance }),
      }}
    />
  )

const PhoneText = (props: Object) => (
  <>
    <glamorous.P
      color={props.showENSubTextRTR ? vxDarkGray : vxGray}
      marginTop={-15}
    >
      {i18n('label.notifyUserText')}
    </glamorous.P>
    {props.showENSubTextRTR && (
      <glamorous.P color={vxGray} fontSize="14px" marginTop={-15}>
        {enRTRStrings['label.notifyUserText']}
      </glamorous.P>
    )}
  </>
)

const STYLES = {
  rtrPrimaryText: {
    color: vxDarkGray,
  },
}

const PurchaseProtectionText = (props: Object) =>
  isDw2Repaint() ? (
    <>
      <CaptionText as={PurchaseProtectionTextDiv}>
        {i18n('shield.explanation', {
          purchaseProtectionLink: (
            <PPLink
              size="sm"
              href={i18n('unified.purchaseProtectionLink')}
              target="_blank"
              onClick={() =>
                tracking(
                  Events.p2p_payment_type_terms_pressed({
                    suggested_protection_design: props.suggestedDesign,
                    protection_design: props.moneyPageOverPanel,
                  })
                )
              }
            >
              {i18n('shield.paypalPurchaseProtection')}
            </PPLink>
          ),
        })}
      </CaptionText>
    </>
  ) : (
    <p
      className="txtCenter vx_text-legal"
      style={props.showENSubTextRTR ? STYLES.rtrPrimaryText : {}}
    >
      {i18n('shield.explanation', {
        purchaseProtectionLink: (
          <a
            href={i18n('unified.purchaseProtectionLink')}
            target="_blank"
            onClick={() =>
              tracking(
                Events.p2p_payment_type_terms_pressed({
                  suggested_protection_design: props.suggestedDesign,
                  protection_design: props.moneyPageOverPanel,
                })
              )
            }
          >
            {i18n('shield.paypalPurchaseProtection')}
          </a>
        ),
      })}
    </p>
  )

const PurchaseGoodsOnlyText = (props: Object) => (
  <CaptionText
    className="txtCenter vx_text-legal"
    style={{ margin: '23px 16px 40px', letterSpacing: '-0.02rem' }}
  >
    {i18n('shield.purchaseGoodsOnly.send')}
  </CaptionText>
)

const PurchaseProtectionENSubTextRTR = (props: Object) =>
  isDw2Repaint() ? (
    <PurchaseProtectionTextDiv>
      <CaptionText as={ProtectionENSubTextRTR}>
        {enRTRStrings['shield.explanation']}{' '}
      </CaptionText>
      <PPLink
        size="sm"
        href={enRTRStrings['unified.purchaseProtectionLink']}
        target="_blank"
        onClick={() =>
          tracking(
            Events.p2p_payment_type_terms_pressed({
              suggested_protection_design: props.suggestedDesign,
              protection_design: props.moneyPageOverPanel,
            })
          )
        }
      >
        {enRTRStrings['shield.paypalPurchaseProtection']}
      </PPLink>
    </PurchaseProtectionTextDiv>
  ) : (
    <p className="txtCenter vx_text-legal">
      {enRTRStrings['shield.explanation']}
      <a
        href={enRTRStrings['unified.purchaseProtectionLink']}
        target="_blank"
        onClick={() =>
          tracking(
            Events.p2p_payment_type_terms_pressed({
              suggested_protection_design: props.suggestedDesign,
              protection_design: props.moneyPageOverPanel,
            })
          )
        }
      >
        {enRTRStrings['shield.paypalPurchaseProtection']}
      </a>
    </p>
  )

const ShippingAddressWrapper = glamorous.div(
  {
    background: 'white',
    padding: '1em',
    border: '1px solid #f2f2f2',
    marginBottom: '1em',
    ...(isDw2Repaint() && { ...BOX_BORDER_STYLES }),
  },
  ({ condensedUI }) =>
    condensedUI && {
      padding: '.5em',
      marginBottom: '.5em',
      border: 'unset',
    }
)

const LogoutLink = () => (
  <a
    className="logout_link txtCenter btn-link"
    href="/myaccount/transfer/logoutNotification"
  >
    {i18n('outlook.logout')}
  </a>
)

const TravelRuleWrapper = glamorous.div({
  background: 'white',
  padding: '1em',
  border: '1px solid #f2f2f2',
  marginBottom: '1em',
  ...(isDw2Repaint() && { ...BOX_BORDER_STYLES }),
})

const CancelLink = glamorous.button({
  display: 'block',
  textAlign: 'center',
  margin: '0 auto',
})

const SubmitButtonWrapper = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '24px',
})

const SubmitButton = glamorous
  .button(
    'vx_btn',
    {
      transform: 'none',
      width: '70%',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    ({ shouldDisable }) =>
      shouldDisable && {
        color: '#cbd2d6',
        background: '#f5f6f8',
        boxShadow: 'none',
        border: '1px solid #cbd2d6',
        textDecoration: 'none',
        cursor: 'not-allowed',
        outline: 'none',
        transform: 'none',
      }
  )
  .withProps(
    ({ shouldDisable }) => shouldDisable && { 'aria-disabled': shouldDisable }
  )

/**
 * Usually we use pxp to check whether user is in voltron
 * but in this case we have to check url
 * because even for voltron user, they can come to `/myaccount/transfer/send/preview` for external flow
 */

type PreviewProps = {
  isExternal: boolean,
  isDCSendMoneyRequest: boolean,
  selectedFundingOption: FundingOption,
  preselectedFundingOption: FundingOption,
  shouldShowNote: boolean,
  shouldShowDonateAnonymousCheckbox: boolean,
  shouldShowHeaderBox: boolean,
  shouldShowAddress: boolean,
  shouldShowXBCountryMismatch: boolean,
  shouldShowUnilateralFields: boolean,
  shouldShowCancelButton: boolean,
  shouldShowLogoutLink: boolean,
  shouldShowDonateContent: boolean,
  shouldShowDonateGiftAid: boolean,
  shouldShowFundingOptionsOverpanel: boolean,
  shouldShowPaymentTypeToggle: boolean,
  shouldDefaultToSuggestedPaymentType: boolean,
  showPurchaseProtection: boolean,
  infoNeededFromCustomer: any,
  moreInfoIsNeededForAssessCapabilities: any,
  isPhoneNumber: boolean,
  isFFEligible: boolean,
  isPisp: boolean,
  isPurchase: boolean,
  payerId: string,
  recipient: string,
  unilateralName: string,
  unilateralCountryCode: string,
  isRecurring: boolean,
  isV2: boolean,
  flowType: string, // TODO: be more specific
  flowIsPayRequest: boolean,
  requestId: string,
  requestLegId: string,
  location: any,
  paymentTypeIsSelected: boolean,
  fundingOptions: FundingOption[],
  hasFetchedFundingOptions: boolean,
  instrumentationPurchaseProtection: {},
  riskHoldOverpanelVariant: string,
  condensedUI: boolean,
  hasConfirmedRiskHolds: boolean,
  hasResolvedCVVContingencies: boolean,
  hasResolved3DSContingencies: boolean,
  hasResolvedDDCContingencies: boolean,
  hasResolved3DS2Contingencies: boolean,
  is3DS2ChallengeRequired: boolean,
  disablePreviewScroll: boolean,
  isLoading: boolean,
  isAmountValid: boolean,
  isPayRequestAmountValid: boolean,
  getExternalComponents: string => any,
  routeToCancelUrl: () => void,
  dispatch: Function,
  rcvr_acct_type: any,
  recurring_type: any,
  amount: any,
  currencyCode: string,
  payRequestAmount: any,
  error: {},
  moneyPageOverPanel: any,
  suggestedDesign: any,
  isGiftEligible: boolean,
  giftOption: string,
  themeId: string,
  successfullyAddedFundingInstrumentIds: string,
  triggerSenderPhoneConfirmation: boolean,
  thumbnailUrl: string,
  displayName: string,
  serviceContext: any,
  suggestedPaymentType: string,
  paymentTypeIsSelected: boolean,
  recipientCountry: string,
  fromCurrencyCode: string,
  recipientAccountType: string,
  noteLength: number,
  receiverFee: string,
  language: string,
  isProfile: boolean,
  isPersonalDisabled: boolean,
  isPurchaseDisabled: boolean,
  recipientType: string,
  isMgm: boolean,
  originAmount: any,
  destinationAmount: any,
  isAddBankFlow: boolean,
  isAmountReadOnly: boolean,
  currencyDecimal: CurrencySeparator,
  isRecipientCurrencyRestricted: boolean,
  senderCountry: string,
  donationContext: any,
  isTipping: boolean,
  history: any,
  showStateMandatedWarning: boolean,
  isPSAEnabled: boolean,
  isBusinessUser: boolean,
  noteFieldRequired: boolean,
  mandatoryNoteToReceiver: NoteVariant,
  isMissingMandatoryNote: boolean,
  showFFFInfoMessage: boolean,
  paymentTypeReviewMessage: string,
  isPpshops: boolean,
  isShippingSelected: boolean,
  isPurchaseConsentChecked: boolean,
  purchaseConsentRequired: boolean,
  purchaseConsentLabel: string,
  purchaseConsentChecked: boolean,
  hasResolvedPurchaseConsent: boolean,
}

type PreviewState = {
  attemptedSubmit: boolean,
  showThemeOverpanel: boolean,
  showNewThemeOverpanel: boolean,
  hasPurchaseConsentError: boolean,
}

/**
 * Preview page for p2p flow, including setting amount and choosing funding option
 */
export class Preview extends Component<PreviewProps, PreviewState> {
  previewTrackingSent: boolean = false
  cancelLink: any = React.createRef()
  paymentTypeSelection: any = React.createRef()
  pageName = getPageName(
    this.props.flowType,
    this.props.recipient,
    !!this.props.selectedFundingOption.id
  )
  pageGroup = getPageGroup(
    this.props.flowType,
    this.props.recipient,
    !!this.props.selectedFundingOption.id
  )

  static defaultProps = {
    selectedFundingOption: {},
    receiverFee: 0,
    showStateMandatedWarning: false,
  }

  state = {
    attemptedSubmit: false,
    showThemeOverpanel: false,
    showNewThemeOverpanel: false,
    hasPurchaseConsentError: false,
  }

  componentDidMount() {
    const {
      dispatch,
      flowType,
      flowIsPayRequest,
      recipientCountry,
      currencyCode,
      fromCurrencyCode,
      recipientAccountType,
      noteLength,
      isProfile,
      isMgm,
      isRecipientCurrencyRestricted,
      senderCountry,
    } = this.props

    const { changeIsPurchase, triggerExternalHook } = ViewActions
    const isReview = isReviewPage(this.props)
    if (isMgm) {
      dispatch(initializeMGMAmount())
    }
    if (isRecipientCurrencyRestricted) {
      tracking(
        Events.p2p_international_currency_disabled_disclosure_shown({
          sender_currency: fromCurrencyCode,
          sender_country: senderCountry,
          receiver_country: recipientCountry,
          receiver_currency: currencyCode,
        })
      )
    }

    if (flowIsPayRequest) {
      const decisionObj = {
        serviceContext: this.props.serviceContext,
        suggestedPaymentType: this.props.suggestedPaymentType,
      }
      trackServiceAndClientDecision(decisionObj)

      // paymentTypeIsSelected: true for the case when user is routed back to P2P from wallet external flows
      if (
        !this.props.shouldDefaultToSuggestedPaymentType &&
        !this.props.hasFetchedFundingOptions &&
        !this.props.paymentTypeIsSelected
      ) {
        return dispatch(togglePaymentTypeChoiceOverpanel({ show: true }))
      }
      dispatch(ViewActions.setPaymentTypeSelected(true))

      if (
        this.props.shouldDefaultToSuggestedPaymentType &&
        ((this.props.isPurchaseDisabled && this.props.isPurchase) ||
          (this.props.isPersonalDisabled && !this.props.isPurchase))
      ) {
        this.props.dispatch(
          redirectToHomeinfo(this.props.isPurchase ? 'buy' : 'send')
        )
      }
      if (
        !this.props.hasFetchedFundingOptions &&
        !this.props.noteFieldRequired
      ) {
        // we check first if we've already fetched, since we could be coming back from the funding option selector interstitial
        this.props.dispatch(PayRequestActions.fetchFundingOptions())
      }
    } else {
      // Just to ensure url is in sync with store value
      // TODO: use either store or url as single source of truth
      dispatch(changeIsPurchase(flowType === 'buy'))
    }
    dispatch(triggerExternalHook('previewPageAfterRender', this.props))
    if (!isReview) {
      if (this.props.isExternal) {
        if (isProfile) {
          Events.updateCommonProps({
            source: PROFILE_SOURCE.SEND,
            sub_flow: 'send_money',
          })
        }

        // Set MGM common props after being redirected back to p2p (ie: from add bank)
        if (isMgm) {
          setMgmTrackingCommonProps()
        }

        // if user lands on amount/preview page directly, consider it as a start
        tracking(Events.p2p_flow_started())
      }
      tracking(
        Events.p2p_amount_screen_shown({
          receiver_country: recipientCountry,
          receiver_currency: currencyCode,
          sender_currency: fromCurrencyCode,
          receiver_account_type: recipientAccountType,
          page_variant: 'p2p_existing',
          note_character_length: noteLength,
        })
      )
      trackAmountPageImpression(flowType, this.props.recipient, {
        flfr: window.flfr,
      })
      window.flfr = null // remove flfr so it will not be captured when payment choice overpanel is opened
    }
  }

  componentWillUnmount() {
    const {
      selectedFundingOption,
      history,
      hasResolvedDDCContingencies,
      hasResolved3DS2Contingencies,
      is3DS2ChallengeRequired,
      dispatch,
    } = this.props

    // Avoid duplicate lookup calls when Browser back button is pressed while the 3DS process is ongoing.
    if (
      isBrowserBackPressedFor3DSFlow(
        hasResolvedDDCContingencies,
        selectedFundingOption,
        hasResolved3DS2Contingencies,
        is3DS2ChallengeRequired,
        history
      )
    ) {
      // set refetchFundingOptionFor3DS to true for handling duplicate lookup calls issue
      dispatch(SendActions.refetchFundingOption3DS())
      this.refetchFundingOption()
    }
  }

  componentDidUpdate(prevProps: PreviewProps) {
    const {
      flowType,
      fundingOptions,
      selectedFundingOption,
      recipient,
      moneyPageOverPanel,
      suggestedDesign,
      successfullyAddedFundingInstrumentIds,
      dispatch,
      flowIsPayRequest,
      requestId,
      requestLegId,
      recipientCountry,
      isPurchase,
      receiverFee,
      currencyCode,
      fromCurrencyCode,
      recipientAccountType,
      noteLength,
      triggerSenderPhoneConfirmation,
      amount,
      payerId,
      thumbnailUrl,
      displayName,
      isAddBankFlow,
      showStateMandatedWarning,
      originAmount,
    } = this.props

    const isReview = isReviewPage(this.props)

    if (!isReview) {
      this.previewTrackingSent = false
    }

    // This check is to prevent the use case when user tries to access the preview page directly for phone confirmation flow
    if (isReview && triggerSenderPhoneConfirmation) {
      const data = {
        flowType,
        amount,
        currencyCode,
        payerId,
        recipient,
        displayName,
        thumbnailUrl,
      }
      dispatch(redirectToDolphin(data))
    }

    const newFundingOption = getOptionById(
      fundingOptions,
      successfullyAddedFundingInstrumentIds
    )
    const newFundingOptionIsAvailable = isFundingOptionAvailable(
      fundingOptions,
      successfullyAddedFundingInstrumentIds
    )
    // Set the confirmed funding option as selected
    if (
      isAddBankFlow &&
      newFundingOptionIsAvailable &&
      newFundingOption.id !== selectedFundingOption.id
    ) {
      batch(() => {
        dispatch(SendActions.saveSuccessfullyAddedFundingInstrumentIds(''))
        dispatch(
          ViewActions.changeSelectedFundingOption(
            successfullyAddedFundingInstrumentIds,
            {}
          )
        )
      })
    }

    // update page name in case we switch from amount to review or vice versa
    this.pageName = getPageName(flowType, recipient, isReview)
    this.pageGroup = getPageGroup(flowType, recipient, isReview)

    if (
      flowType !== '' &&
      shouldShowSelectorInterstitial(prevProps, this.props)
    ) {
      // TODO: Eventually use startCPLTracking, but data is not being saved correctly right now
      // startCPLTracking('main:p2p:choice:fioption', 'main:p2p:choice:fioption::node', data)
      const url = window.location.pathname || ''
      const isVoltron = url.includes('homepage')
      routeTo(`${isVoltron ? '/homepage' : ''}/${flowType}/select`)
    }
    if (flowIsPayRequest) {
      const {
        location: { search },
      } = this.props
      // This two lines of code captures the params if its nobalance/ CFPB flow for payrequest
      const params = { ...parseSearch(search) }
      if (params.cipFlow) {
        this.props.dispatch(ViewActions.captureExternalParams(params))
      }

      if (shouldShowSelectorInterstitial(prevProps, this.props)) {
        routeTo(`/payRequest/${requestId}/${requestLegId}/select`)
      }
    }

    if (
      isReview &&
      !this.props.shouldShowFundingOptionsOverpanel &&
      !this.previewTrackingSent
    ) {
      const { funding_sources = [] } = selectedFundingOption
      const fiHasCashAdvanceFee = funding_sources.some(
        source => source.cashAdvanceFeeApplies === true
      )

      if (flowType === 'payRequest') {
        this.trackPayRequestImpression()
      }

      if (isReview && this.props.showFFFInfoMessage) {
        this.props.dispatch(ViewActions.toggleFFFInfoMessage(false))
      }

      tracking(
        Events.p2p_review_screen_shown({
          default_fi_type: getFundingNameType(selectedFundingOption).fi_type,
          fi_name: getFundingNameType(selectedFundingOption).fi_name,
          suggested_protection_design: suggestedDesign,
          receiver_country: recipientCountry,
          ...getFeePayerTracking(),
          payment_type: isPurchase ? 'purchase' : 'personal',
          receiver_currency: currencyCode,
          fee: receiverFee,
          sender_currency: fromCurrencyCode,
          protection_design: moneyPageOverPanel,
          fi_warning_type: fiHasCashAdvanceFee ? 'cash_advance' : '',
          receiver_account_type: recipientAccountType,
          page_variant: 'p2p_existing',
          note_character_length: noteLength,
          disclaimer_shown: showStateMandatedWarning ? 'fraud_warning' : 'none',
          receiver_amount_local_currency: amount,
          sender_amount:
            currencyCode === fromCurrencyCode ? amount : originAmount,
          payment_type_review_message: this.props.paymentTypeReviewMessage
            ? 'y'
            : 'n',
        })
      )

      this.previewTrackingSent = true
    }
    if (
      !this.props.disablePreviewScroll &&
      !this.props.isLoading &&
      justSelectedFundingOption(prevProps, this.props)
    ) {
      if (
        !prevProps.shouldShowFundingOptionsOverpanel &&
        !justSetPreferredSource(prevProps, this.props)
      ) {
        trackImpression(
          this.pageGroup,
          this.pageName,
          getAnalytics({
            selectedFundingOption,
            fundingOptions,
            flowType,
          })
        )
      }
    }
  }

  trackPayRequestImpression = () => {
    const pageGroup = 'main:p2p:payrequest::review'
    const pageName = 'main:p2p:payrequest::review:node::'
    trackImpression(pageGroup, pageName, {
      ...this.getAnalyticsObject(),
      flfr: 'start',
    })
  }

  shallShowRiskHoldsMessage = () => {
    const { hasConfirmedRiskHolds, riskHoldOverpanelVariant } = this.props
    return (
      hasTwentyFourHourHoldsVariant(riskHoldOverpanelVariant) &&
      !hasConfirmedRiskHolds
    )
  }

  getAnalyticsObject = () => {
    const {
      selectedFundingOption = {},
      fundingOptions = [],
      isPurchase,
    } = this.props

    const preferred = getPreferredFundingSource(fundingOptions) || { id: '' }
    const selectedFOExists = !!Object.keys(selectedFundingOption).length
    const dflFmxId =
      selectedFOExists &&
      selectedFundingOption.funding_sources.map(source => source.id)
    const usingPreferred =
      selectedFOExists &&
      selectedFundingOption.funding_sources.some(source => source.isPreferred)

    const fltp = isPurchase ? 'g&s' : 'f&f'
    const dfl_fmxid = dflFmxId ? dflFmxId.toString() : 'nodefault'
    const pref_fmxid = preferred.id || 'notset'
    const is_pref = usingPreferred ? 'Y' : 'N'
    const threeDS2Contingency = extract3DS2Contingency(selectedFundingOption)
    const has3DS2Contingency = !isEmpty(threeDS2Contingency)
    const threeDS2ReferenceId = has3DS2Contingency
      ? threeDS2Contingency.three_ds_reference_id
      : ''

    const fundingSource = getRelevantFundingSource(selectedFundingOption)
    const sourceName = getFundingSourceName(fundingSource)

    return {
      fltp,
      dfl_fmxid,
      pref_fmxid,
      is_pref,
      is_3ds_eligible: has3DS2Contingency,
      '3ds_ref_id': threeDS2ReferenceId,
      sel_fmx_tp: sourceName,
    }
  }

  sendPayment = () => {
    const {
      dispatch,
      instrumentationPurchaseProtection,
      flowIsPayRequest,
    } = this.props

    // set attemptedSubmit to true for error handling of travel rule fields
    this.setState({ attemptedSubmit: true })

    dispatch(
      ViewActions.triggerExternalHook('previewPageSendSubmit', this.props)
    )

    // TODO trackLink('Send', `main:p2p:${getFlowType()}::review`, `main:p2p:${getFlowType()}::review:node::`, 'link')

    if (flowIsPayRequest) {
      trackClickUnifiedSend('payRequestSend')
      dispatch(PayRequestActions.handlePayRequestSubmit())
    } else {
      dispatch(SendActions.handleSendSubmit())
    }
    trackPurchaseProtectionSelection(
      {
        pageGroup: this.pageGroup,
        pageName: this.pageName,
        link: 'purchaseprotectionselection',
      },
      instrumentationPurchaseProtection
    )
  }

  handleCancel = (e: any) => {
    e.preventDefault()
    const { isPisp, dispatch, routeToCancelUrl } = this.props
    // Incase of pisp, we do not need to dispatch this action since
    // user will be redirected to an external page
    if (!isPisp) dispatch(ViewActions.cancelledTransaction())
    if (!isReviewPage(this.props)) tracking(Events.p2p_amount_cancel_pressed())
    routeToCancelUrl()
  }

  trackClickContinueOnAmountPage = () => {
    const { recipient, giftOption } = this.props
    const urlPathName = window.location.pathname || ''
    const unified = urlPathName.includes('homepage')
    const unifiedString = unified ? 'unified:' : ''
    const emailOrPhone = isEmail(recipient) ? 'email' : 'phone'
    const flowType = getFlowType()

    let pageGroup = `main:p2p:${unifiedString}${flowType}::${emailOrPhone}`
    let pageName = `main:p2p:${unifiedString}${flowType}::${emailOrPhone}:node::`

    let optsel
    if (giftOption === 'ecard') {
      optsel = 'personal_ecard'
    }

    trackLink('Continue', pageName, pageGroup, 'link', null, {
      optsel,
    })
  }

  handleSubmit = (e: any = { preventDefault: () => {} }) => {
    e.preventDefault()
    const {
      hasResolvedCVVContingencies,
      hasResolved3DSContingencies,
      hasResolvedDDCContingencies,
      hasResolved3DS2Contingencies,
      hasFetchedFundingOptions,
      flowIsPayRequest,
      is3DS2ChallengeRequired,
      isV2,
      selectedFundingOption,
      preselectedFundingOption,
      dispatch,
      moneyPageOverPanel,
      giftOption,
      themeId,
      recipient,
      triggerSenderPhoneConfirmation,
      amount,
      currencyCode,
      fromCurrencyCode,
      payerId,
      displayName,
      thumbnailUrl,
      moreInfoIsNeededForAssessCapabilities,
      recipientCountry,
      recipientAccountType,
      noteLength,
      noteFieldRequired,
      suggestedDesign,
      isPurchase,
      receiverFee,
      isPersonalDisabled,
      isPurchaseDisabled,
      originAmount,
      destinationAmount,
      isAmountReadOnly,
      donationContext,
      history,
      isDCSendMoneyRequest,
      purchaseConsentChecked,
      purchaseConsentRequired,
      hasResolvedPurchaseConsent,
    } = this.props

    if (noteFieldRequired && !noteLength) {
      /**
       * This check indicates that note field is required but empty.
       * User needs to see the mandatory description field error
       * */
      return this.showNoteFieldError(true)
    }

    this.showNoteFieldError(false)

    const isReview = isReviewPage(this.props)
    /**
     * This check indicates that purchase consent is required but unchecked.
     * User needs to see the purchase consent field error
     * */
    if (purchaseConsentRequired && !purchaseConsentChecked && isReview) {
      return this.setState({ hasPurchaseConsentError: true })
    } else if (purchaseConsentRequired && purchaseConsentChecked && isReview) {
      this.setState({ hasPurchaseConsentError: false })
    }

    const showMinimumDonationInvalidError =
      env === 'donate' &&
      !amountAboveMinimumDonation(
        isAmountReadOnly,
        amount,
        donationContext.minimum_amount,
        currencyCode
      )
    const showMaximumDonationInvalidError =
      env === 'donate' &&
      !amountBelowMaximumDonation(
        isAmountReadOnly,
        amount,
        donationContext.maximum_amount,
        currencyCode
      )
    // minimum donation validation for donate flow
    if (showMinimumDonationInvalidError) {
      this.props.dispatch({
        type: types.EXTERNAL.SHOW_AMOUNT_DONATION_ERROR,
        data: DONATION_VALIDATION_TYPES.AMOUNT_BELOW_MINIMUM,
      })
      return
    }

    // maximum donation validation for donate flow
    if (showMaximumDonationInvalidError) {
      this.props.dispatch({
        type: types.EXTERNAL.SHOW_AMOUNT_DONATION_ERROR,
        data: DONATION_VALIDATION_TYPES.AMOUNT_ABOVE_MAXIMUM,
      })
      return
    }

    if (!showMaximumDonationInvalidError && !showMinimumDonationInvalidError) {
      this.props.dispatch({
        type: types.EXTERNAL.HIDE_AMOUNT_DONATION_ERROR,
      })
    }

    // because we don't really disable submit button due to a11y issues, we want to check whether we should submit
    const shouldDisableSubmit = this.disableSubmit(isReview)

    if (shouldDisableSubmit) return

    if (isReview) {
      const { funding_sources = [] } = selectedFundingOption
      const fiHasCashAdvanceFee = funding_sources.some(
        source => source.cashAdvanceFeeApplies === true
      )
      tracking(
        Events.p2p_review_submit_pressed({
          ...getFundingNameType(selectedFundingOption),
          suggested_protection_design: suggestedDesign,
          receiver_country: recipientCountry,
          ...getFeePayerTracking(),
          payment_type: isPurchase ? 'purchase' : 'personal',
          receiver_currency: currencyCode,
          fee: receiverFee,
          sender_currency: fromCurrencyCode,
          protection_design: moneyPageOverPanel,
          fi_warning_type: fiHasCashAdvanceFee ? 'cash_advance' : '',
          receiver_account_type: recipientAccountType,
          note_character_length: noteLength,
          payment_type_review_message: this.props.paymentTypeReviewMessage
            ? 'y'
            : 'n',
        })
      )
    } else {
      tracking(
        Events.p2p_amount_next_pressed({
          receiver_country: recipientCountry,
          receiver_amount_local_currency:
            currencyCode === fromCurrencyCode ? amount : destinationAmount,
          receiver_currency: currencyCode,
          sender_amount:
            currencyCode === fromCurrencyCode ? amount : originAmount,
          sender_currency: fromCurrencyCode,
          receiver_account_type: recipientAccountType,
          note_character_length: noteLength,
        })
      )
    }

    if (giftOption) {
      if (giftOption === GIFT_OPTIONS.ecard && !themeId) {
        return this.toggleNewThemeOverpanel()
      }
      if (giftOption === GIFT_OPTIONS.ppdg) {
        trackLink('continue', this.pageName, this.pageGroup, 'link', null, {
          optsel: 'brand_egift_card',
        })
        return dispatch(ViewActions.routeToPPDG(recipient))
      }
    }

    if (!isReview) {
      let flowType = getFlowType()

      this.trackClickContinueOnAmountPage()
      if (
        isV2 &&
        (FEE_REQUIRED_VARIANTS.includes(moneyPageOverPanel) ||
          moreInfoIsNeededForAssessCapabilities)
      ) {
        return dispatch(updateTxn())
      }

      if (
        (flowType === 'buy' && isPurchaseDisabled) ||
        (flowType === 'send' && isPersonalDisabled)
      ) {
        return handleInterstitialCipFlow()
      }

      if (
        flowIsPayRequest &&
        ((isPurchaseDisabled && isPurchase) ||
          (isPersonalDisabled && !isPurchase))
      ) {
        return handleInterstitialCipFlow(isPurchase ? 'buy' : 'send')
      }

      // if we know the payment type, make FI call
      if (flowType === 'buy' || flowType === 'send') {
        if (triggerSenderPhoneConfirmation) {
          const data = {
            flowType,
            amount,
            currencyCode,
            payerId,
            recipient,
            displayName,
            thumbnailUrl,
          }
          return dispatch(redirectToDolphin(data))
        }
        return dispatch(
          SendActions.fetchFundingOptions({ preselectedFundingOption })
        )
      }

      if (
        this.props.paymentTypeIsSelected &&
        flowIsPayRequest &&
        !hasFetchedFundingOptions
      ) {
        return dispatch(PayRequestActions.fetchFundingOptions())
      }

      /*
         We make the third assess capabilities call for variants that need a fee or the
         service response provides field back on whether to make the third call
      */

      if (
        FEE_REQUIRED_VARIANTS.includes(moneyPageOverPanel) ||
        moreInfoIsNeededForAssessCapabilities
      ) {
        return dispatch(sendMoreInfoToAssessCapabilities())
      }

      // the final option is to show the payment type choice overpanel
      return dispatch(togglePaymentTypeChoiceOverpanel({ show: true }))
    }

    if (isReview && isDCSendMoneyRequest) {
      return dispatch(
        SendActions.setDualControlContext({
          handleNext: () =>
            dispatch(
              SendActions.fetchFundingOptions({
                handleFISelectorNext: () =>
                  dispatch(SendActions.handleSendMoneyRequest()),
              })
            ),
        })
      )
    }

    if (isReview && purchaseConsentRequired && !hasResolvedPurchaseConsent) {
      return dispatch(SendActions.handlePurchaseConsent(this.handleSubmit))
    }

    if (this.shallShowRiskHoldsMessage()) {
      return dispatch(OverpanelActions.toggleRiskHoldsOverpanel({ show: true }))
    }

    if (!hasResolvedCVVContingencies && selectedFundingOption.showCvv) {
      return dispatch(SendActions.handleCVV(this.handleSubmit))
    }

    // resolve 3DS if any
    if (!hasResolved3DSContingencies && selectedFundingOption.show3DS) {
      return dispatch(OverpanelActions.toggle3DSecureOverpanel({ show: true }))
    }

    // resolve DDC contingency for 3DS2.0 if any
    if (
      !hasResolvedDDCContingencies &&
      selectedFundingOption.hasDDCContingency
    ) {
      const browserContext = collectBrowserContext()
      return dispatch(
        SendActions.resolveDDC(
          this.handleSubmit,
          history,
          false,
          browserContext
        )
      )
    }

    let flowType = getFlowType()
    if (
      (flowType === 'buy' && isPurchaseDisabled) ||
      (flowType === 'send' && isPersonalDisabled)
    ) {
      return handleInterstitialCipFlow()
    }

    // resolve challenge contingency for 3DS2.0 if any
    if (!hasResolved3DS2Contingencies && is3DS2ChallengeRequired) {
      return dispatch(
        OverpanelActions.toggle3DS2ChallengeOverpanel({ show: true })
      )
    }

    this.sendPayment()
  }

  toggleThemeOverpanel = () => {
    this.setState({ showThemeOverpanel: !this.state.showThemeOverpanel })
  }

  toggleNewThemeOverpanel = () => {
    this.setState(
      { showNewThemeOverpanel: !this.state.showNewThemeOverpanel },
      () => {
        if (this.state.showNewThemeOverpanel) {
          const pageGroup = 'main:consumer:p2p:choose_design'
          const pageName = 'main:consumer:p2p:choose_design::'
          trackImpression(pageGroup, pageName)
        }
      }
    )
  }

  // Shall only be used for PPMe, which only has send or buy
  // flow types
  togglePurchaseProtection = () => {
    const currentFlowType = getFlowType()
    const newFlowType = currentFlowType === 'send' ? 'buy' : 'send'
    const isPurchase = newFlowType === 'buy'
    const { preselectedFundingOption } = this.props
    routeTo(`/${newFlowType}/preview`, { replace: true })
    this.props.dispatch(
      ViewActions.changeIsPurchase(isPurchase, { isToggle: !isPurchase })
    )

    if (isPurchase) {
      this.props.dispatch(ViewActions.hasRedirectedFromSend())
    }
    this.props.dispatch(
      SendActions.fetchFundingOptions({ preselectedFundingOption })
    )
  }

  togglePurchaseConsentCheckbox = () => {
    const purchaseConsentChecked = !this.props.purchaseConsentChecked
    this.props.dispatch(
      SendActions.setPurchaseConsentValue(purchaseConsentChecked)
    )
    this.setState({ hasPurchaseConsentError: false })
  }

  refetchFundingOption = () => {
    const {
      isAmountValid,
      isPayRequestAmountValid,
      dispatch,
      preselectedFundingOption,
      flowIsPayRequest,
      isDCSendMoneyRequest,
    } = this.props

    if (isDCSendMoneyRequest) return
    // if user has already selected a funding option,
    // we immediately refetch FI instead of asking user to click "continue"
    const isReview = isReviewPage(this.props)
    if (flowIsPayRequest && isReview && isPayRequestAmountValid) {
      dispatch(PayRequestActions.fetchFundingOptions())
    } else if (isReview && isAmountValid) {
      dispatch(SendActions.fetchFundingOptions({ preselectedFundingOption }))
    }
  }

  handleGiftOption = (selectedOption: any) => {
    this.props.dispatch(ViewActions.changeGiftOption(selectedOption))
  }

  trackPayRequestChangePurchaseProtection = (isPurchase: boolean) => {
    const pageGroup = 'main:consumer:p2p:transfer:payRequest'
    const pageName = `${pageGroup}:preview:${isPurchase ? 'G&S' : 'F&F'}`
    trackLink('ChangeFFGS', pageGroup, pageName, 'link')
  }

  handleTogglePaymentType = () => {
    const { selectedFundingOption, recipient, flowType } = this.props
    const isBuyFlow = flowType === 'buy'
    if (selectedFundingOption.id) {
      if (flowType === 'payRequest') {
        this.trackPayRequestChangePurchaseProtection(this.props.isPurchase)
      } else {
        trackClickUnifiedSend(
          isBuyFlow ? 'onGSchangePaymentType' : 'onFFchangePaymentType'
        )
      }
    } else {
      trackAmountPageClick(isBuyFlow ? 'buy' : 'send', recipient, 'change')
    }
  }

  shouldRenderUnilateralFields = () => {
    const { shouldShowUnilateralFields, infoNeededFromCustomer } = this.props
    return (
      (infoNeededFromCustomer && !!infoNeededFromCustomer.length) ||
      shouldShowUnilateralFields
    )
  }

  renderUnilateralFields = (showENSubTextRTR: boolean) => {
    /* TODO the unilateral fields component should be dynamic to show one field or other.
        We can complete this after moving the Money Page
    */

    if (this.shouldRenderUnilateralFields()) {
      return <UnilateralFields showENSubTextRTR={showENSubTextRTR} />
    }
  }

  showNoteFieldError = (error: boolean, fromCloseButton: boolean = false) => {
    const ifBackfromReviewPage = isReviewPage({
      ...this.props,
      isMissingMandatoryNote: false,
    })

    if (ifBackfromReviewPage && fromCloseButton) {
      return
    }
    this.props.dispatch(mandatoryNoteMissing(error))
  }

  disableSubmit = (isReview: boolean) => {
    const {
      flowIsPayRequest,
      isPayRequestAmountValid,
      fundingOptions,
      isAmountValid,
      isDCSendMoneyRequest,
      isPpshops,
      shouldShowAddress,
      isShippingSelected,
    } = this.props

    const disable = flowIsPayRequest
      ? !isPayRequestAmountValid || (isReview && !fundingOptions.length)
      : !isAmountValid ||
        (isReview && !(isDCSendMoneyRequest || fundingOptions.length))

    if (isPpshops) {
      return disable || (shouldShowAddress && !isShippingSelected)
    }
    return disable
  }

  render() {
    const {
      selectedFundingOption,
      shouldShowNote,
      shouldShowDonateAnonymousCheckbox,
      shouldShowHeaderBox,
      shouldShowAddress,
      shouldShowXBCountryMismatch,
      shouldShowCancelButton,
      shouldShowLogoutLink,
      shouldShowDonateContent,
      shouldShowDonateGiftAid,
      shouldShowPaymentTypeToggle,
      showPurchaseProtection,
      isAmountValid,
      isPhoneNumber,
      isFFEligible,
      isRecurring,
      isPisp,
      isMgm,
      isPurchase,
      condensedUI,
      flowType,
      flowIsPayRequest,
      payRequestAmount,
      getExternalComponents,
      giftOption,
      isGiftEligible,
      themeId,
      triggerSenderPhoneConfirmation,
      paymentTypeIsSelected,
      language,
      isRecipientCurrencyRestricted,
      isDCSendMoneyRequest,
      isPSAEnabled,
      isBusinessUser,
      mandatoryNoteToReceiver = null,
      purchaseConsentRequired,
      purchaseConsentLabel,
      purchaseConsentChecked,
    } = this.props

    const isReview = isReviewPage(this.props)
    const currencyCodeMessage = getCurrencyCodeMessage(PRODUCT_FLOWS.SEND)
    const {
      displayAmounts: { sent = '', totalReceiverFee = null } = {},
      isRTR = false,
    } = selectedFundingOption
    const cancelButtonSource = isPisp ? 'link.back' : 'link.cancel'

    // disable continue button when amount is invalid or user has no funding option
    const shouldDisableSubmit = this.disableSubmit(isReview)

    const showENSubTextRTR =
      isReview === true && isRTR === true && language !== 'en'

    const previewNoteLabel = this.props.noteFieldRequired
      ? get(mandatoryNoteToReceiver, 'message', '')
      : get(serverProps, 'recipientData.previewNoteLabel', '')

    const isInMgmCustomNotesTreatment = isMgm && hasMgmCustomNotesTreatment()
    const showNote = shouldShowNote || isInMgmCustomNotesTreatment
    const isXoom = isSendAbroadFlow()
    return (
      <DocumentTitle title={i18n('a11y.title.send.preview')}>
        <Fragment>
          {this.props.isMissingMandatoryNote && (
            <NoteFieldMandatoryError
              noteMandatoryMsg={i18n('mandatory.note.msg')}
              onClose={() => this.showNoteFieldError(false, true)}
            />
          )}
          <Form
            onSubmit={this.handleSubmit}
            style={isBusinessUser ? { paddingTop: 0 } : {}}
          >
            {shouldShowHeaderBox && (
              <HeaderBoxWrapper condense={condensedUI}>
                <NegativeBalance
                  selectedFundingOption={selectedFundingOption}
                />
                <RecipientHeader />

                {isPhoneNumber && (
                  <PhoneText showENSubTextRTR={showENSubTextRTR} />
                )}

                <ConvertibleAmountField
                  isReview={isReview}
                  payRequestAmount={
                    flowIsPayRequest ? payRequestAmount : undefined
                  }
                />
                <p className="txtBold">
                  {isReview && isRecipientCurrencyRestricted
                    ? currencyCodeMessage
                    : undefined}
                </p>
                {isRecurring && <span>{i18n('label.perMonth')}</span>}

                {shouldShowDonateGiftAid && <DonateGiftAid />}
                {shouldShowDonateAnonymousCheckbox && (
                  <DonateAnonymousCheckbox />
                )}
                {shouldShowPaymentTypeToggle &&
                  isReview &&
                  !isXoom &&
                  !showPurchaseProtection && (
                    <PaymentTypeToggle
                      totalReceiverFee={totalReceiverFee}
                      showENSubTextRTR={showENSubTextRTR}
                      flowType={isPurchase ? 'buy' : 'send'}
                      onToggle={this.handleTogglePaymentType}
                      innerRef={this.paymentTypeSelection}
                    />
                  )}

                {showNote && (
                  <NoteWithGift
                    isReview={isReview}
                    showENSubTextRTR={showENSubTextRTR}
                    recipient={this.props.recipient}
                    openThemeOverpanel={this.toggleThemeOverpanel}
                    openNewThemeOverpanel={this.toggleNewThemeOverpanel}
                    isGiftEligible={this.props.isGiftEligible}
                    dispatch={this.props.dispatch}
                    previewNoteLabel={previewNoteLabel}
                  />
                )}

                {showPurchaseProtection && (
                  <PurchaseProtectionCheckbox
                    flowType={getFlowType()}
                    handleChangePurchaseProtection={
                      this.togglePurchaseProtection
                    }
                    isFriendsFamilyEligible={isFFEligible}
                    containerStyle={{ marginTop: '0.5rem' }}
                  />
                )}
              </HeaderBoxWrapper>
            )}
            {isPurchase && shouldShowAddress && isReview && (
              <ShippingAddressWrapper condensedUI={condensedUI}>
                <ShippingAddressDropdown
                  onAddressChanged={this.refetchFundingOption}
                  showENSubTextRTR={showENSubTextRTR}
                />
              </ShippingAddressWrapper>
            )}
            {shouldShowXBCountryMismatch && <XBFeeMismatch />}
            {/* Show the new gift options only when its eligible to show the gift and gift option is not selected.*/}
            {showNewGiftOptions && isGiftEligible && !isReview && !themeId && (
              <GiftOptions
                handleChangeGiftOption={this.handleGiftOption}
                giftOption={giftOption}
                pageName={this.pageName}
                pageGroup={this.pageGroup}
              />
            )}
            {isReview && !isDCSendMoneyRequest && (
              <SendSelectedFundingOption isReview={isReview} />
            )}
            {travelRuleUtils.isTravelRule(selectedFundingOption) && (
              <TravelRuleWrapper>
                <TravelRule attemptedSubmit={this.state.attemptedSubmit} />
              </TravelRuleWrapper>
            )}
            {this.renderUnilateralFields(showENSubTextRTR)}
            {isReview && isPSAEnabled && <PurchaseGoodsOnlyText />}

            {purchaseConsentRequired &&
              isReview &&
              (isDw2Repaint() ? (
                <PurchaseConsentCheckBoxWrapper>
                  <PurchaseConsentCheckBox
                    handleChangePurchaseConsentCheckbox={
                      this.togglePurchaseConsentCheckbox
                    }
                    isPurchaseConsentChecked={purchaseConsentChecked}
                    purchaseConsentLabelText={purchaseConsentLabel}
                    hasPurchaseConsentError={this.state.hasPurchaseConsentError}
                  />
                </PurchaseConsentCheckBoxWrapper>
              ) : (
                <PurchaseConsentCheckBox
                  handleChangePurchaseConsentCheckbox={
                    this.togglePurchaseConsentCheckbox
                  }
                  isPurchaseConsentChecked={purchaseConsentChecked}
                  purchaseConsentLabelText={purchaseConsentLabel}
                  hasPurchaseConsentError={this.state.hasPurchaseConsentError}
                />
              ))}

            {isPurchase && (
              <>
                {getExternalComponents('before:userAgreement')}
                {!shouldShowDonateContent && (
                  <PurchaseProtectionText
                    showENSubTextRTR={showENSubTextRTR}
                    suggestedDesign={this.props.suggestedDesign}
                    moneyPageOverPanel={this.props.moneyPageOverPanel}
                  />
                )}
              </>
            )}
            <Disclosure hasENSubTextRTR={showENSubTextRTR} />
            {showENSubTextRTR && (
              <>
                {isPurchase && !shouldShowDonateContent && (
                  <PurchaseProtectionENSubTextRTR
                    suggestedDesign={this.props.suggestedDesign}
                    moneyPageOverPanel={this.props.moneyPageOverPanel}
                  />
                )}
                <Disclosure showENSubTextRTR={showENSubTextRTR} />
              </>
            )}
            {isDw2Repaint() ? (
              <SubmitButtonWrapper>
                {/* $FlowFixMe */}
                <Button
                  // $FlowFixMe
                  className={css({
                    ...(shouldDisableSubmit && {
                      color: '#cbd2d6',
                      background: '#f5f6f8',
                      boxShadow: 'none',
                      border: '1px solid #cbd2d6',
                      textDecoration: 'none',
                      cursor: 'not-allowed',
                      outline: 'none',
                      transform: 'none',
                      ':after': {
                        content: 'none',
                      },
                    }),
                    [mobileAndSmaller]: {
                      width: '100%',
                      margin: '0 1rem',
                    },
                  }).toString()}
                  // $FlowFixMe
                  {...(shouldDisableSubmit && { 'aria-disabled': 'true' })}
                  data-nemo={isReview ? 'send' : 'continue'}
                >
                  {getSubmitButtonContent({
                    amount: sent,
                    isReview,
                    shouldShowDonateContent,
                    isRecurring,
                    isDCSendMoneyRequest,
                    isPSAEnabled,
                  })}
                </Button>
              </SubmitButtonWrapper>
            ) : (
              <SubmitButton
                shouldDisable={shouldDisableSubmit}
                data-nemo={isReview ? 'send' : 'continue'}
              >
                {getSubmitButtonContent({
                  amount: sent,
                  isReview,
                  shouldShowDonateContent,
                  isRecurring,
                  isDCSendMoneyRequest,
                  isPSAEnabled,
                })}
              </SubmitButton>
            )}
            {shouldShowCancelButton &&
              (isDw2Repaint() ? (
                <CancelLinkWrapper>
                  <ButtonLink
                    ref={this.cancelLink}
                    onClick={this.handleCancel}
                    data-pagename={this.pageName}
                    data-nemo="cancel-btn"
                  >
                    {i18n(cancelButtonSource)}
                  </ButtonLink>
                </CancelLinkWrapper>
              ) : (
                <CancelLink
                  type="button"
                  className="vx_btn-link"
                  innerRef={this.cancelLink}
                  onClick={this.handleCancel}
                  data-pagename={this.pageName}
                  data-nemo="cancel-btn"
                >
                  {i18n(cancelButtonSource)}
                </CancelLink>
              ))}
            {shouldShowLogoutLink && <LogoutLink />}
          </Form>
          {/**
           * Overpanels: place those you wish to appear on top of others (if multiple were to
           * ever be open at the same time) first in the render method.
           */}
          <ThreeDSOverpanel onSuccess={this.handleSubmit} />
          <ThreeDS2OverPanel
            onSuccess={this.handleSubmit}
            dispatch={this.props.dispatch}
          />
          <ThreeDS2SpinnerOverpanel />
          <RiskHoldsOverpanel onSubmit={this.handleSubmit} />
          {/* if overpanel is closed with a flow type determined, we redirect */}
          <PaymentTypeChoiceOverpanel
            themeId={themeId}
            giftOption={giftOption}
            isAmountValid={isAmountValid}
            isDCSendMoneyRequest={isDCSendMoneyRequest}
            flowType={flowType}
            paymentTypeIsSelected={paymentTypeIsSelected}
            triggerSenderPhoneConfirmation={triggerSenderPhoneConfirmation}
            onClosed={() => {
              if (flowType) {
                return false
              }
              routeTo('/homepage/preview')
            }}
          />
          <CurrencyConversionSelectionOverpanel />

          {!showNewGiftOptions && (
            <ThemeSelectionOverpanel
              show={this.state.showThemeOverpanel}
              handleCloseButton={this.toggleThemeOverpanel}
              onSubmitTheme={this.refetchFundingOption}
              onRemoveTheme={this.refetchFundingOption}
            />
          )}

          {showNewGiftOptions && (
            <NewThemeSelectionOverpanel
              show={this.state.showNewThemeOverpanel}
              handleCloseButton={this.toggleNewThemeOverpanel}
              onSubmitTheme={this.refetchFundingOption}
            />
          )}
          <CIPOverpanels />
          <ConfirmIdentityOverpanel />
        </Fragment>
      </DocumentTitle>
    )
  }
}

export default connect(
  ({
    server,
    recipient,
    user,
    transaction,
    amount,
    crossBorder,
    external,
    loading,
    overpanels,
    errors,
    giftOption,
    theme,
    unilateral,
    note,
    donate,
    address,
  }) => ({
    isDCSendMoneyRequest: get(
      server,
      'businessAccountInfo.isDCSendMoneyRequest',
      false
    ),
    isExternal: server.isExternal,
    rcvr_acct_type: recipient.recipientAccountType,
    recurring_type: recipient.recurringType,
    isPurchase: transaction.isPurchase,
    shouldShowNote:
      !external.hidePreviewNote && !server.isMgm && !recipient.isNoteRestricted,
    shouldShowDonateAnonymousCheckbox: donate.showDonateAnonymousCheckbox,
    shouldShowHeaderBox: server.env !== 'pools',
    shouldShowAddress:
      server.env !== FLOW_TYPES.PPSHOPS
        ? !external.hideAddress &&
          !isHideShippingAddress(
            transaction.shippingAddressCollectionPreference
          )
        : transaction.shippingType === SHIPPING_TYPES.FLAT_RATE ||
          transaction.shippingType === SHIPPING_TYPES.FREE,
    shouldShowXBCountryMismatch: Boolean(crossBorder.xbCountryMismatch),
    shouldShowUnilateralFields: Boolean(transaction.showUnilateralFields),
    infoNeededFromCustomer: recipient.infoNeededFromCustomer,
    moreInfoIsNeededForAssessCapabilities:
      recipient.moreInfoIsNeededForAssessCapabilities,

    shouldShowCancelButton: !external.shouldHideCancelButton,
    shouldShowLogoutLink: server.env === 'outlook',
    shouldShowDonateContent:
      Boolean(external.showDonateContent) || transaction.isCrowdFundingCampaign,
    shouldShowDonateGiftAid: Boolean(
      external.donationGiftAid && external.donationGiftAid.isGiftaidAllowed
    ),
    shouldShowFundingOptionsOverpanel: overpanels.fundingOptionsOverpanel,
    hasConfirmedRiskHolds: overpanels.hasConfirmedRiskHolds,
    shouldShowPaymentTypeToggle:
      getFlowType() !== 'gift' &&
      server.env !== 'donate' &&
      server.env !== 'pools',
    shouldDefaultToSuggestedPaymentType:
      transaction.shouldDefaultToSuggestedPaymentType,
    isPisp: server.env === 'pisp',
    isPhoneNumber: Boolean(
      recipient.recipientId &&
        recipient.recipient &&
        isPhoneNumberMaybe(recipient.recipient)
    ),
    isFFEligible: server.isFFEligible,
    recipient: recipient.recipient,
    payerId: recipient.payerId,
    moneyPageOverPanel: recipient.moneyPageOverPanel,
    suggestedDesign: recipient.suggestedDesign,
    amount: amount.amount,
    currencyCode: amount.currencyCode,
    fromCurrencyCode: amount.fromCurrencyCode,
    payRequestAmount: server.payRequestAmount,
    error: errors.overpanel,
    isRecurring: Boolean(external.isRecurring),
    selectedFundingOption: transaction.selectedFundingOption || {},
    preselectedFundingOption: transaction.preselectedFundingOption || {},
    successfullyAddedFundingInstrumentIds:
      transaction.successfullyAddedFundingInstrumentIds || '',
    hasFetchedFundingOptions: Boolean(transaction.hasFetchedFundingOptions),
    hasFundingOptions: !!transaction.fundingOptions.length,
    fundingOptions: transaction.fundingOptions || [],
    condensedUI: Boolean(external.showCondensedUI), // hide gifting and remove extra padding, etc.
    disablePreviewScroll: Boolean(external.disablePreviewScroll),
    isLoading: Boolean(loading.isLoading),
    isAmountValid:
      !amountIsZero(amount.amount, amount.currencyDecimal) &&
      !(
        crossBorder.isLoadingDestinationAmount || crossBorder.isInDebounceWindow
      ),
    isPayRequestAmountValid:
      server.payRequestAmount &&
      !amountIsZero(
        server.payRequestAmount,
        server.payRequestCurrencyDecimal
      ) &&
      !crossBorder.isLoadingDestinationAmount,
    originAmount: crossBorder.originAmount,
    destinationAmount: crossBorder.destinationAmount,
    hasResolvedCVVContingencies: transaction.hasResolvedCVVContingencies,
    hasResolved3DSContingencies: transaction.hasResolved3DSContingencies,
    hasResolvedDDCContingencies: transaction.hasResolvedDDCContingencies,
    hasResolved3DS2Contingencies: transaction.hasResolved3DS2Contingencies,
    unilateralName: unilateral.name,
    unilateralCountryCode: unilateral.countryCode,
    is3DS2ChallengeRequired: transaction.is3DS2ChallengeRequired,
    showPurchaseProtection: server.env === 'ppme',
    flowType: getFlowType(),
    flowIsPayRequest: getFlowType() === 'payRequest',
    requestId: server.requestId,
    requestLegId: server.requestLegId,
    paymentTypeIsSelected: transaction.paymentTypeIsSelected,
    themeId: theme.themeId,
    giftOption: giftOption.giftOption,
    getExternalComponents: getHookComponents(server.env, 'preview'),
    user,
    instrumentationPurchaseProtection:
      user.instrumentationData.purchaseProtection,
    language: user.language,
    routeToCancelUrl: () => {
      if (server.isMgm) {
        return routeTo(
          `/homepage/external/mgm?traffic_source=${getTrafficSource()}`,
          { replace: true }
        )
      }
      if (server.env === 'summary' || getFlowType() === 'payRequest') {
        return window.location.replace('/myaccount/summary')
      }
      if (server.env === 'xb') {
        return routeTo('/', { replace: true })
      }
      if (server.env === 'pisp') {
        return handleCancelRedirect()
      }
      if (server.env === 'shops') {
        if (hasMultiItemCartShops()) {
          return (window.location.href = recipient.networkId
            ? `/paypalme/${recipient.networkId}/buy/cart`
            : '/myaccount/summary')
        }

        return (window.location.href =
          recipient.networkId && server.recipientData.productId
            ? `/paypalme/${recipient.networkId}/products/${server.recipientData.productId}`
            : '/myaccount/summary')
      }
      routeTo('/', { replace: true })
    },
    isGiftEligible:
      (server.env !== 'pisp' || external.giftingSupported) &&
      !server.isNativeApp &&
      !server.businessAccountInfo.isBusinessUser &&
      !external.showCondensedUI &&
      !['buy', 'request', 'payRequest'].includes(getFlowType()),
    riskHoldOverpanelVariant: transaction.riskHoldOverpanelVariant,
    triggerSenderPhoneConfirmation:
      server.triggerSenderPhoneConfirmation ||
      user.triggerSenderPhoneConfirmation,
    displayName: recipient.displayName,
    thumbnailUrl: recipient.thumbnailUrl,
    serviceContext: recipient.serviceContext,
    suggestedPaymentType: recipient.suggestedPaymentType,
    recipientCountry: recipient.country,
    recipientAccountType: recipient.recipientAccountType,
    noteLength: note.note.trim().length,
    receiverFee: amount.receiverFee,
    isPersonalDisabled: user.isPersonalDisabled,
    isPurchaseDisabled: user.isPurchaseDisabled,
    isV2:
      server.isV2 &&
      recipient.token &&
      server.env !== 'donate' &&
      server.env !== 'pisp' &&
      server.env !== 'pools' &&
      server.env !== 'ppme',
    isProfile: server.analyticsFlow === 'profile',
    recipientType: recipient.recipientType,
    isMgm: server.isMgm || server.env === 'mgm',
    isAddBankFlow: serverProps.obFlow === OPEN_BANKING_FLOWS.ADD_BANK,
    isAmountReadOnly: Boolean(external.isAmountReadOnly),
    currencyDecimal: amount.currencyDecimal,
    isRecipientCurrencyRestricted: recipient.isRecipientCurrencyRestricted,
    senderCountry: user.country,
    donationContext: external.donationContext,
    showStateMandatedWarning: transaction.showStateMandatedWarning,
    isPSAEnabled: server.isPSAEnabled,
    isBusinessUser: server.businessAccountInfo.isBusinessUser,
    noteFieldRequired: (
      (recipient.paymentExperience &&
        recipient.paymentExperience.mandatoryFlowAttributes) ||
      (server.recipientData.paymentExperience &&
        server.recipientData.paymentExperience.mandatoryFlowAttributes) ||
      []
    ).includes(REQUIRED_FLOW_ATTRIBUTES.NOTE_TO_RECEIVER),
    mandatoryNoteToReceiver:
      (recipient.paymentExperience &&
        recipient.paymentExperience.mandatoryNoteToReceiver) ||
      (server.recipientData.paymentExperience &&
        server.recipientData.paymentExperience.mandatoryNoteToReceiver) ||
      null,
    isMissingMandatoryNote: note.isMissingMandatoryNote,
    showFFFInfoMessage: transaction.showFFFInfoMessage,
    paymentTypeReviewMessage: transaction.paymentTypeReviewMessage,
    isPpshops: server.env === FLOW_TYPES.PPSHOPS,
    isShippingSelected:
      address.selectedShippingAddress &&
      Object.keys(address.selectedShippingAddress).length > 0,
    purchaseConsentPreChecked: transaction.purchaseConsentPreChecked,
    purchaseConsentChecked: transaction.purchaseConsentChecked,
    purchaseConsentLabel: transaction.purchaseConsentLabel,
    purchaseConsentRequired: transaction.purchaseConsentRequired,
    hasResolvedPurchaseConsent: transaction.hasResolvedPurchaseConsent,
  })
)(Preview)
